import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Order extends React.Component {
  update() {
    let m = this.score.value.split(':');
    
    let options = this.props.options;
    options.order = { column: m[0], type: m[1] };
    this.props.search_ev.bind(this)(options);
  }
  // -------------------------------------------------------
  
  render() {
    let order = [];
    let options = this.props.options;
    
    if( this.props.mode == 'account' ){
      order = [
        { column: 'recommend',           type: 'desc', name: 'AIQスコアの高い順' },
        { column: 'followers',           type: 'desc', name: 'フォロワー数が多い順' },
        { column: 'post_interval',       type: 'asc',  name: '投稿頻度が高い順' },
        { column: 'good_assign',         type: 'desc', name: 'アサイン数の多い順' },
        { column: 'last_post_date_diff', type: 'desc', name: '最新アクティブ順' },
      ];
    }
    
    if( this.props.mode == 'post' ){
      if( options.product_type == undefined ) options.product_type = 'REELS';
      
      if( options.product_type == 'REELS' ){
        order = [
          { column: 'plays_per', type: 'desc', name: '再生率が高い順' },
          { column: 'plays',     type: 'desc', name: '再生数が多い順' },
          { column: 'post_date', type: 'desc', name: '投稿日時が新しい順' },
          { column: 'likes',     type: 'desc', name: 'いいね数が多い順' },
          { column: 'comments',  type: 'desc', name: 'コメント数が多い順' },
        ];
      } else if( options.product_type == 'STORY' ){
        order = [
          { column: 'post_date',   type: 'desc', name: '投稿日時が新しい順' },
          { column: 'impressions', type: 'desc', name: 'インプレッション数が多い順' },
          { column: 'reach',       type: 'desc', name: 'リーチ数が多い順' },
        ];
      } else {
        order = [
          { column: 'likes',     type: 'desc', name: 'いいね数が多い順' },
          { column: 'post_date', type: 'desc', name: '投稿日時が新しい順' },
          { column: 'comments',  type: 'desc', name: 'コメント数が多い順' },
        ];
      }
    }
    
    return (
      <div className="influencer-search-order">
        <div className="selectbox">
          <select id="search-order" ref={(input) => { this.score = input }} onChange={this.update.bind(this)} defaultValue={this.props.default}>
            { order.map((d, key) => {
              return <option key={key} value={d.column +':'+ d.type}>{d.name}</option>
             })}
          </select>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Order;